import { Body, Controller, Param, Post } from '@nestjs/common'
import { lastValueFrom } from 'rxjs'
import { WebhookAplicacionService } from '../../../../plataforma/services/aplicacion.server.services'
import { WebhookWhatsappServerService } from '../../../services/whatsapp/whatsapp.server.service'

@Controller('webhook/whatsapp/dispatcher/:apiKey')
export class WebhookDispatcherMensajeWhatsappController {
  constructor(
    private aplicacionService: WebhookAplicacionService,
    private webhookWhatsappServerService: WebhookWhatsappServerService,
  ) {}

  @Post()
  async post(@Param('apiKey') apiKey: string, @Body() data: any) {
    if (!apiKey) throw new Error(JSON.stringify({ error: true }))

    const aplicacion = await this.aplicacionService.obtenerAplicacionApi(apiKey)
    if (data.message.template) {
      //namespace = e21740d8_c857_46d1_b9c9_f35340c5b919
      const dataTemplate = {
        to: data.to,
        key: aplicacion.token,
        template: data.message.template.nombre,
        namespace: 'e21740d8_c857_46d1_b9c9_f35340c5b919',
      }

      return this.webhookWhatsappServerService.sendTemplate(dataTemplate, data.message.template.parameters)
    }
    let type = 'text'
    if (data.message.message.attachments.length) {
      type = data.message.message.attachments[0].type
    }

    const dataMensaje = {
      mensaje: data.message.message.attachments.length
        ? data.message.message.attachments[0].url
        : data.message.message.text.body,
      to: data.to,
      key: aplicacion.token,
    }

    return lastValueFrom(this.webhookWhatsappServerService.sendSimple(dataMensaje, type))
  }
}
